<template>
  <span class="oido-icon" v-html="svg" ></span>
</template>


<script >

const icons = {
  'clipboard': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path d="M336 64h32a48 48 0 0148 48v320a48 48 0 01-48 48H144a48 48 0 01-48-48V112a48 48 0 0148-48h32" stroke-linejoin="round" class="ionicon-fill-none ionicon-stroke-width"></path><rect x="176" y="32" width="160" height="64" rx="26.13" ry="26.13" stroke-linejoin="round" class="ionicon-fill-none ionicon-stroke-width"></rect></svg>`,
  'c': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><circle cx="256" cy="256" r="192" stroke-linecap="round" stroke-linejoin="round" class="ionicon-fill-none ionicon-stroke-width"></circle></svg>`,
  'checkbox-empty': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><circle cx="256" cy="256" r="192" stroke-linecap="round" stroke-linejoin="round" class="ionicon-fill-none ionicon-stroke-width"></circle></svg>`,
  'checkbox-checked': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z" stroke-miterlimit="10" class="ionicon-fill-none ionicon-stroke-width"></path><path stroke-linecap="round" stroke-linejoin="round" d="M352 176L217.6 336 160 272" class="ionicon-fill-none ionicon-stroke-width"></path></svg>`,
  'close': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path stroke-linecap="round" stroke-linejoin="round" d="M368 368L144 144M368 144L144 368" class="ionicon-fill-none ionicon-stroke-width"></path></svg>`,
  'help': `<svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><path d="M256 80a176 176 0 10176 176A176 176 0 00256 80z" stroke-miterlimit="10" class="ionicon-fill-none ionicon-stroke-width"></path><path d="M200 202.29s.84-17.5 19.57-32.57C230.68 160.77 244 158.18 256 158c10.93-.14 20.69 1.67 26.53 4.45 10 4.76 29.47 16.38 29.47 41.09 0 26-17 37.81-36.37 50.8S251 281.43 251 296" stroke-linecap="round" stroke-miterlimit="10" stroke-width="28" class="ionicon-fill-none"></path><circle cx="250" cy="348" r="20"></circle></svg>`
}


export default {
  props: {
    name: String,
    stroke: String,
    strokeWidth: String,
    size: String,
  },
  computed: {
    svg() {
      let svg = null
      if (icons[this.name]) {
        svg = icons[this.name]
      }
      if(svg){
        let styles = '';
        if(this.stroke){
          styles += `stroke: ${this.stroke}!important;`;
        }
        if(this.size){
          styles += `width: ${this.size}!important;`;
        }
        if(this.strokeWidth){
          styles += `stroke-width: ${this.strokeWidth}!important;`;
        }
        svg = svg.replace('<svg ', `<svg style="${styles}" ` );
      }
      return svg;
    }

  }
}

</script>


<style scoped>

</style>
<style>
.oido-icon svg {  
  stroke: black;
  fill: transparent;
  stroke-width: 50px;
}
</style>


